export const incidentInvolvedVehicleFormRules = {
  licenseNumber: [{ required: true, message: 'License number is required!' }],
  licenseState: [{ required: true, message: 'License state is required!' }],
};
